import { Injectable } from '@angular/core';

export interface CurrentUser {
  id?: number;
  token: string;
  role?: number;
  studioId?: number;
  ownerId?: number;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private readonly KEY = 'ngStorage-currentUser';

  get currentUser(): CurrentUser | null {
    try {
      const raw = sessionStorage.getItem(this.KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  set currentUser(value: CurrentUser | null) {
    if (value) {
      sessionStorage.setItem(this.KEY, JSON.stringify(value));
    } else {
      sessionStorage.removeItem(this.KEY);
    }
  }

  get token(): string | null {
    return this.currentUser?.token ?? null;
  }

  get isLoggedIn(): boolean {
    return !!this.token;
  }

  get returnToPath(): string | null {
    return sessionStorage.getItem('returnToPath');
  }

  set returnToPath(path: string | null) {
    if (path) sessionStorage.setItem('returnToPath', path);
    else sessionStorage.removeItem('returnToPath');
  }

  clearSession(): void {
    Object.keys(sessionStorage).forEach(key => {
      // Recovery records are owned by their workflow and survive reauthentication.
      if (key !== this.KEY && !key.startsWith('sfRecovery:')) sessionStorage.removeItem(key);
    });
  }

  logout(): void {
    this.currentUser = null;
  }
}
